/**
 * Shown when a user tries to start data entry while they still owe an overread feedback
 * acknowledgement. Only reachable when the project has
 * "Require Overread Feedback Acknowledgment before Data Entry" turned on - when it is off the
 * database returns a receipt status of RequestedNotRequired and the user is let through.
 */
export const OVERREAD_FEEDBACK_REVIEW_REQUIRED_MESSAGE = "Please review Overread Feedback before proceeding";
